import { SFPalette } from '@/lib/color';

export default function SFArrowDropdownIcon({ color = SFPalette.lightGrey2 }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 12.5456L14.7549 10.2916C14.9622 10.122 15.2603 10.122 15.4676 10.2916V10.2916C15.7429 10.5168 15.7429 10.9376 15.4676 11.1628L12 14L8.53236 11.1628C8.25715 10.9376 8.25715 10.5168 8.53236 10.2916V10.2916C8.73968 10.122 9.03782 10.122 9.24514 10.2916L12 12.5456Z"
        fill={color}
      />
    </svg>
  );
}
